import React from "react";
import {
  KTMScreen,
  ActionEvent,
  RenderEvent,
  renderScreen,
  Line,
} from "ktm-ui";
import { KTMApi } from "api/KTMApi";
import {
  Layout,
  Dialog,
  Button,
  Display,
  Card,
  DataGrid,
  IDataGridLayout,
} from "ktm-ui";
import CustomToolTip from "../../components/CustomToolTip";
import { Modal, Button as ReactButton } from "react-bootstrap";
import axios from "axios";

interface IdsExpenseTypes {
  isSelected: boolean;
  Id: string;
  AccountType: string;
  Code: string;
  ShortName: string;
  Description: string;
}

interface IdsForm {
  Coverage: number;
}

interface IStates {
  counter: number;
  showConfirmation: boolean;
  showError: boolean;
  expenseTypes: IdsExpenseTypes[];
}

export default KTMScreen(
  { name: "enroll.ben-limit.add-expense-types" },
  class extends React.Component<
    {
      policy_id: string;
      limit_id: string;
      bencat_id: string;
    },
    IStates
  > {
    data: {
      dsExpenseTypes: IdsExpenseTypes;
      dsForm: IdsForm;
    };

    state: IStates = {
      counter: 0,
      showConfirmation: false,
      showError: false,
      expenseTypes: [],
    };

    render() {
      return renderScreen(this);
    }

    async start({ screen }: ActionEvent) {
      screen.defaultRecord = "@dsExpenseTypes";
      await KTMApi.start(screen, {
        "@policy_id": this.props.policy_id,
        "@limit_id": this.props.limit_id,
        "@bencat_id": this.props.bencat_id,
      });
      screen.title = "Add Expense Types";

      await this.getExpenseTypes();
    }

    main({ field, draw, action }: RenderEvent) {
      return (
        <Layout dialogSize="large">
          {draw(this.header)}
          {draw(this.coverage)}
          {draw(this.expense_type_grid)}
          {draw(this.footer)}
          {this.state.showConfirmation && this.renderPASAcknowledgment()}
          {this.state.showError && this.renderDuplicateExpenseError()}
        </Layout>
      );
    }

    header({ field, draw, action }: RenderEvent) {
      return <Dialog.Header label="Add Expense Types" />;
    }

    footer({ field, draw, action }: RenderEvent) {
      return (
        <Dialog.Footer>
          <Button action={action(this.submit)} label="Add" style="primary" />
        </Dialog.Footer>
      );
    }

    expense_type_grid({ field, draw, action, collection }: RenderEvent) {
      let layout: IDataGridLayout = {
        rowSelector: true,
        columns: [
          { name: "AccountType", label: "Account Type", type: "character" },
          { name: "Code", label: "Code", type: "character", width: 300 },
          {
            name: "ShortName",
            label: "Short Name",
            type: "character",
            width: 500,
          },
        ],
        sort: [{ name: "AccountType" }, { name: "Code" }],
      };

      return (
        <DataGrid collection={collection("@dsExpenseTypes")} layout={layout} />
      );
    }

    coverage({ field, draw, action }: RenderEvent) {
      return (
        <Card>
          <Display
            field={field("@dsForm.Coverage")}
            toolTip={
              <CustomToolTip
                header="Coverage (%)"
                bodyContent="Shortcut to apply the same Copay to every expense."
              />
            }
          />
        </Card>
      );
    }

    incrementCounter = () => {
      this.setState((prev) => ({ counter: prev.counter + 1 }));
    };

    renderPASAcknowledgment() {
      return (
        <Modal
          show={this.state.showConfirmation}
          style={{ top: 250, zIndex: 10000 }}
          centered
        >
          <Modal.Header>Acknowledgement</Modal.Header>
          <Modal.Body
            style={{ maxHeight: 400, overflowY: "auto", color: "red" }}
          >
            <Card>
              <Line>
                <span style={{ fontSize: 14 }}>
                  When choosing Pay-As-Submitted (PAS), please check the
                  following: <br />
                  1. Does the policy have active dependents? <br />
                  2. Does the benefit category allow LSA dependent claims?{" "}
                  <br />
                  If there are active dependents and the category does not allow
                  LSA dependent claims, NHC must confirm with the client that,
                  in order to have PAS, LSA dependent claims must be allowable.{" "}
                  <br />
                  If there are no active dependents, please proceed with adding
                  PAS.
                </span>
              </Line>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <ReactButton
              variant="primary"
              onClick={() => {
                // Hide modal and mark PAS as acknowledged
                this.setState({ showConfirmation: false }, () => {
                  this.incrementCounter();
                });
              }}
            >
              Ok
            </ReactButton>
          </Modal.Footer>
        </Modal>
      );
    }

    renderDuplicateExpenseError() {
      return (
        <Modal
          show={this.state.showError}
          style={{ top: 250, zIndex: 10000 }}
          centered
        >
          <Modal.Header>Duplicate expense type</Modal.Header>
          <Modal.Body
            style={{ maxHeight: 400, overflowY: "auto", color: "red" }}
          >
            <Card>
              <Line>
                <span style={{ fontSize: 14 }}>
                  Error: Expense type duplication (taxable vs non-taxable).
                  Reach out to enrollments for assistance.
                </span>
              </Line>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <ReactButton
              variant="primary"
              onClick={() => {
                this.setState({ showError: false });
              }}
            >
              Ok
            </ReactButton>
          </Modal.Footer>
        </Modal>
      );
    }

    confirmPASExpenseType(expenseList) {
      const isPASSelected = expenseList.some(
        (x) => x.Code === "AA - PAY AS SUBMITTED",
      );

      if (isPASSelected) return true
    }

    isExpenseDuplicated(
      expenseList,
      expenseTypes,
      taxableExpense,
      nonTaxableExpense,
    ) {
      const hasTaxable =
        expenseList.some((e) => taxableExpense.includes(e.Code)) ||
        expenseTypes.some((e) => taxableExpense.includes(e.code));

      const hasNonTaxable =
        expenseList.some((e) => e.Code === nonTaxableExpense) ||
        expenseTypes.some((e) => e.code === nonTaxableExpense);

      return hasTaxable && hasNonTaxable;
    }

    checkExpenseTypesDuplicate(selectedData) {
      const isTaxableFootwearDuplicated = this.isExpenseDuplicated(
        selectedData,
        this.state.expenseTypes,
        ["Footwear (Safety Work Boots)"],
        "Safety Work Boots",
      );
      const isWorkbootsDuplicated = this.isExpenseDuplicated(
        selectedData,
        this.state.expenseTypes,
        ["Footwear (Safety Work Boots)", "Safety Work Boots"],
        "PPE Footwear (Work Boots only) NON-TAXABLE",
      );
      const isPPEDuplicated = this.isExpenseDuplicated(
        selectedData,
        this.state.expenseTypes,
        ["Personal Protective Reflective Clothing"],
        "PPE Reflective Clothing & Equipment NON-TAXABLE",
      );

      if (
        isTaxableFootwearDuplicated ||
        isWorkbootsDuplicated ||
        isPPEDuplicated
      ) {
        return true;
      }
    }

    async submit({ screen }: ActionEvent) {
      const expenseList = screen.field("@dsExpenseTypes").record.dsExpenseTypes;
      const selectedData = expenseList.filter((x) => x.IsSelected === true);

      if(this.state.counter === 0 && this.confirmPASExpenseType(selectedData)){
        this.setState({ showConfirmation: true });
        return;
      }

      if (this.checkExpenseTypesDuplicate(selectedData)) {
        this.setState({ showError: true });
        return;
      }

      await KTMApi.action(screen, "submit");
      screen.close({ continue: true });
    }

    async getExpenseTypes() {
      axios
        .get(
          `/api/BenefitCategories/getexpensetypes?policyId=${this.props.policy_id}&limit_id=${this.props.limit_id}`,
        )
        .then((res) => {
          if (res.data.success) {
            this.setState({
              expenseTypes: res.data.expenseTypes,
            });
          } else {
            console.error(res.data.message, "Error");
          }
        })
        .catch((error) => {
          console.error(error, "Error");
        });
    }
  },
);
